define('store/reducers/session',["exports", "../actions/types", "lodash"], function (exports, _types, _lodash) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _lodash2 = _interopRequireDefault(_lodash);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /*
     * Copyright 2016-2017 ForgeRock AS. All Rights Reserved
     *
     * Use of this code requires a commercial software license with ForgeRock AS.
     * or with one of its affiliates. All use shall be exclusively subject
     * to such license between the licensee and ForgeRock AS.
     */

    var initialState = {
        realm: undefined,
        sessionHandle: undefined
    };

    var session = function session() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
        var action = arguments[1];

        switch (action.type) {
            case _types.SESSION_ADD_INFO:
                {
                    var sessionInfo = {
                        realm: action.realm.toLowerCase(),
                        sessionHandle: action.sessionHandle
                    };

                    return _lodash2.default.merge({}, state, sessionInfo);
                }

            case _types.SESSION_REMOVE_INFO:
                return {};
            default:
                return state;
        }
    };

    exports.default = session;
});

